import '@angular/localize/init';
export * from './lib/feature-tax-income-list.module';

export * from './lib/tax-income-list/feature-tax-income-list.component';
